<template>
<div class="admin-container admin-maps-container">
    <AdminMapsSidebar :periodId="selectedPeriodId" />
    <div class="admin-content">
      <div class="white-box admin-header">
        {{currentDate}}
        <div class="right">
          <select v-model="selectedPeriodId" class="form-select">
            <option v-for="p of filteredPeriods" :value="p.periodId" :key="p.periodId">
              {{($route.name != 'contrats' && $route.name != 'recap') ? (p.label + " (" + p.annee + ")") : ("Campagne " + p.annee)}}
            </option>
          </select>
          <div class="initials">{{$store.state.self.firstname.slice(0, 1)}}{{$store.state.self.name.slice(0, 1)}}</div>
        </div>
      </div>
      <router-view :periodId="selectedPeriodId" :year="selectedPeriod ? selectedPeriod.annee : -1"></router-view>
    </div>
  </div>
</template>

<script>
  import AdminMapsSidebar from "@/components/AdminMapsSidebar";
  import { getAllPeriods } from "@/utils/period";

  export default {
    name: "AdminMaps",
    components: { AdminMapsSidebar },
    data() {
      return {
        periods: [],
        selectedPeriodId: -1
      };
    },
    mounted() {
      getAllPeriods().then(res => {
        let pList = [];
        this.periods.push(...res);
        this.sortPeriods();
        res.forEach(p => {
          const promise = new Promise((resolve) => {
            getAllPeriods(p.annee).then(_res => {
              _res = _res.filter(_p => _p.month !== 12);
              this.periods.push(..._res);
              this.sortPeriods();
              resolve();
            })
          })
          pList.push(promise);
        });
        Promise.all(pList).then(() => {
          if (this.$route.query.periodId) {
            const period = this.periods.find(p => p.periodId == this.$route.query.periodId);
            if (period && period.month == 12)
              this.selectedPeriodId = period.periodId
            else
              this.initLastYearDeclaration();
          } else
            this.initLastYearDeclaration();
        })
      })
    },
    methods: {
      sortPeriods() {
        this.periods = this.periods.sort((a, b) => {
          if (a.annee > b.annee) return -1;
          else if (a.annee < b.annee) return 1;
          else if (a.month < b.month) return -1;
          return 1;
        })
      },
      initLastYearDeclaration() {
        let lastYearPeriod = { periodId: -1, annee: -1, month: 12, label: "Aucune" };
        this.periods.filter(p => p.month == 12).forEach(p => {
          if (p.annee > lastYearPeriod.annee)
            lastYearPeriod = p;
        })
        this.selectedPeriodId = lastYearPeriod.periodId;
      }
    },
    computed: {
      currentDate() {
        const days = ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"];
        const months = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];

        const today = new Date();
        return days[today.getDay()] + " " + today.getDate() + " " + months[today.getMonth()] + " " + today.getFullYear()
      },
      filteredPeriods() {
        if (this.$route.name == "contrats" || this.$route.name == "recap") return this.periods.filter(p => p.month == 12);
        return this.periods;
      },
      selectedPeriod() {
        return this.periods.find(p => p.periodId == this.selectedPeriodId);
      }
    }
  }
</script>

<style scoped>
  .admin-container {
    display: grid;
    grid-template-columns: 100px 1fr;
    min-height: 100vh;
  }

  .admin-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 24px;
    font-size: 18px;
  }

  .admin-header .right {
    height: 100%;
    display: flex;
    align-items: center;
    column-gap: 24px;
  }

    .admin-header .right .initials {
      height: 100%;
      aspect-ratio: 1/1;
      background-color: #50E3C2;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      font-weight: bold;
      color: white;
      font-size: 18px;
    }

  .admin-content {
    padding: 24px;
    display: grid;
    grid-template-rows: 64px 1fr;
    row-gap: 24px;
  }

</style>

<style>
  .admin-maps-container .card .table tr {
    padding: 6px 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Admin/AdminMaps/Admin.vue